import React from "react";
import "./styles/Services.css";
import { Link } from "react-router-dom";

import image1 from "../medias/1.jpg";
import image2 from "../medias/2.jpg";
import image4 from "../medias/4.jpg";
import image8 from "../medias/8.jpg";

const Services = () => {
  return (
    <main className="services-container">
      <section className="services-header">
        <h1>Mes services en travaux publics & géothermie</h1>
        <p>
          Spécialiste des travaux publics et de la géothermie, nous intervenons sur tous types de chantiers : particuliers, collectivités, promoteurs.
          Chaque prestation est réalisée dans les règles de l'art, avec rigueur, sécurité et respect des normes.
        </p>
      </section>

      <section className="services-list">
        <div className="service-item">
          <img src={image2} alt="Pose de gaines électriques enterrées" />
          <h3>Pose de PEHD</h3>
          <p>
            Pose de conduites PEHD pour réseaux enterrés, en tranchée ou en fourreau, selon la configuration du site. Matériel certifié pour réseaux électriques ou hydrauliques.
          </p>
        </div>

        <div className="service-item">
          <img src={image1} alt="Branchement de coffrets de chantier" />
          <h3>Pose et réglage de collecteur géothermie</h3>
          <p>
            Installation et mise en service de collecteurs géothermiques, avec réglage précis pour optimiser le rendement des systèmes de chauffage ou climatisation.
          </p>
        </div>

        <div className="service-item">
          <img src={image4} alt="Création de tranchées techniques" />
          <h3>Réalisation de tranchée sous espace vert ou voirie</h3>
          <p>
            Ouverture de tranchées en domaine public ou privé, avec mise en sécurité des réseaux, pose de gaines, et remise en état propre du terrain.
          </p>
        </div>

        <div className="service-item">
          <img src={image8} alt="Raccordement réseau ENEDIS" />
          <h3>Réalisation de soudure</h3>
          <p>
            Réalisation de soudures électro-guidées et raccordements conformes aux exigences ENEDIS. Intervention rapide avec dossier technique complet.
          </p>
        </div>
      </section>

      <section className="services-why">
        <h2>Pourquoi me faire confiance ?</h2>
        <ul>
          <li>✅ Entreprise déclarée avec assurance décennale</li>
          <li>✅ Devis gratuit sous 24h, intervention rapide</li>
          <li>✅ Engagement sur les délais et la conformité</li>
          <li>✅ Expérience en chantier public et privé</li>
        </ul>
      </section>

      <section className="services-contact-cta">
        <h2>Besoin d'un devis ?</h2>
        <p>Expliquez-moi votre projet, je vous réponds sous 24h.</p>
        <Link to="/contact" className="services-cta-btn">
            Contactez-moi
        </Link>
      </section>
    </main>
  );
};

export default Services;
